<template>
  <div class="notify-manage">
    <div class="container-fluid py-4">
      <h2 class="h4 fw-medium mb-4">{{ $t('__notifyManage.title') }}</h2>
      <!-- 篩選區 -->
      <div class="d-flex flex-wrap mb-3">
        <div class="me-2 mb-2">
          <select v-model="filterStatus" class="form-select rounded-pill" @change="loadNotifies(1)">
            <option :value="null">{{ $t('__all') }}</option>
            <option v-for="opt in statusOptionsModal" :key="opt.value" :value="opt.value">
              {{ $t(opt.textKey) }}
            </option>
          </select>
        </div>
        <div class="me-2 mb-2">
          <select v-model="filterAgencyId" class="form-select rounded-pill" @change="loadNotifies(1)">
            <option :value="null">{{ $t('__all') }} ({{ $t('__agencyName') }})</option>
            <option v-for="a in agencies" :key="a.id" :value="a.id">
              {{ a.name + ' / ' + a.codename }}
            </option>
          </select>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <b-table
            :responsive="$store.state.windowWidth > $store.state.breakpoints.sm"
            :stacked="$store.state.windowWidth <= $store.state.breakpoints.sm"
            striped
            borderless
            head-variant="light"
            selectable
            :items="notifies.data"
            :fields="fields"
            :current-page="notifies.current_page"
            :per-page="notifies.per_page"
          >
            <template #cell(agency)="{ item }">
              {{ item.agency ? item.agency.name + ' / ' + item.agency.codename : '-' }}
            </template>
            <template #cell(resident)="{ item }">
              {{ item.notify && item.notify.resident ? item.notify.resident.name : '-' }}
            </template>
            <template #cell(type)="{ item }">
              {{ item.notify ? $t(`__notifyMessage.${item.notify.type}`) : '-' }}
            </template>
            <template #cell(message)="{ item }">
              <span class="pre-line">
                {{ $t(`__notifyMessageContent.${item.notify.type}`, { value: item.notify.message }) }}
              </span>
            </template>

            <template #cell(status)="{ item }">
              <span class="badge" :class="statusBadgeVariant(item.status)">
                {{ $t(statusKey(item.status)) }}
              </span>
            </template>

            <template #cell(created_at)="{ item }">
              <span>{{ new Date(item.notify.created_at).format('yyyy-MM-dd hh:mm:ss') }}</span>
            </template>
            <template #cell(actions)="{ item }">
              <button class="btn btn-sm btn-primary" @click="openModal(item)">
                {{ $t('__notifyManage.manage') }}
              </button>
            </template>
          </b-table>
        </div>
      </div>

      <!-- 分頁 -->
      <div class="row align-items-center mt-3" v-if="notifies.total">
        <div class="col-sm text-sm-left text-center">
          {{ $t('__paginationInfo', { startNub: (notifies.current_page - 1) * notifies.per_page + 1, entNub: Math.min(notifies.current_page * notifies.per_page, notifies.total), sum: notifies.total }) }}
        </div>
        <div class="col-sm text-sm-right text-center">
          <b-pagination
            v-model="notifies.current_page"
            :total-rows="notifies.total"
            :per-page="notifies.per_page"
            align="right"
            first-number
            last-number
            @change="loadNotifies"
          />
        </div>
      </div>

      <!-- 管理彈窗 -->
      <div class="modal fade" id="changeStatusModal" tabindex="-1" ref="changeStatusModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header justify-content-center">
              <h5 class="modal-title">{{ $t('__changeStatus') }}</h5>
            </div>
            <div class="modal-body" v-if="modalData">
              <p class="mb-3">
                {{ $t('__notifyManage.fieldAgency') }} ： {{ modalData.agency ? modalData.agency.name + '/' + modalData.agency.codename : '-' }} <br />
                {{ $t('__notifyManage.fieldResident') }} ： {{ modalData.notify && modalData.notify.resident ? modalData.notify.resident.name : '-' }} <br />
                {{ $t('__notifyManage.fieldMessage') }}：{{ modalData.notify ? $t(`__notifyMessageContent.${modalData.notify.type}`, { value: modalData.notify.message }) : '-' }} <br />
                {{ $t('__notifyManage.fieldCreatedAt') }} : {{ modalData.notify ? new Date(modalData.notify.created_at).format('yyyy-MM-dd hh:mm:ss') : '-' }}
              </p>
              <p class="mb-3">{{ $t('__notifyManage.changeStatusNote') }}</p>
              <b-form-group :label="$t('__notifyManage.fieldStatus')" class="mb-3">
                <v-select
                  v-model="modalData.newStatus"
                  :options="statusOptionsModal"
                  :get-option-label="option => $t(option.textKey)"
                  :reduce="o => o.value"
                  :placeholder="$t('__notifyManage.statusPlaceholder')"
                  class="style-chooser"
                />
              </b-form-group>
              <b-form-group :label="$t('__notifyManage.fieldWsMessage')">
                <b-form-textarea v-model="modalData.newMessage" rows="3" :placeholder="$t('__notifyManage.wsPlaceholder')" />
              </b-form-group>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-outline-secondary rounded-pill" data-bs-dismiss="modal">{{ $t('__cancel') }}</button>
              <button type="button" class="btn btn-primary rounded-pill" @click="submitModal(modalData)">{{ $t('__confirm') }}</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { Modal } from 'bootstrap';
import { notifyReport } from '@/http/api/notifyReport';
import { agency } from '@/http/api/agency';
import { chat } from "@/http/api/chat";

export default {
  name: 'NotifyManage',
  components: { vSelect },
  data() {
    return {
      notifies: { data: [], total: 0, per_page: 10, current_page: 1 },
      agencies: [],
      filterStatus: null,
      filterAgencyId: null,
      modalData: null,
      statusOptionsModal: [
        { value: 0, textKey: '__notifyManage.statusPending' },
        { value: 1, textKey: '__notifyManage.statusInProgress' },
        { value: 2, textKey: '__notifyManage.statusDone' }
      ],
      fields: [
        { key: 'id', label: this.$t('__notifyManage.fieldId'), sortable: true },
        { key: 'agency', label: this.$t('__notifyManage.fieldAgency') },
        { key: 'resident', label: this.$t('__notifyManage.fieldResident') },
        { key: 'type', label: this.$t('__notifyManage.fieldType') },
        { key: 'message', label: this.$t('__notifyManage.fieldMessage') },
        { key: 'created_at', label: this.$t('__notifyManage.fieldCreatedAt') },
        { key: 'status', label: this.$t('__notifyManage.fieldStatus') },
        { key: 'actions', label: this.$t('__notifyManage.fieldActions') }
      ]
    };
  },
  computed: {
    ...mapState(['token']),
  },
  methods: {
    statusBadgeVariant(status) {
      switch (status) {
        case 0: return 'bg-info';
        case 1: return 'bg-warning';
        case 2: return 'bg-success';
        default: return 'bg-secondary';
      }
    },
    ...mapMutations(["Loading", "Loaded", "AlertsInfo", "Alerted"]),
    async loadNotifies(page = this.notifies.current_page) {
      this.notifies.current_page = page;
      const params = {
        page,
        per_page: this.notifies.per_page
      };
      if (this.filterStatus !== null) params.status = this.filterStatus;
      if (this.filterAgencyId !== null) params.agency_id = this.filterAgencyId;
      const res = await notifyReport.get('', this.token, params);
      if (res.status <= 201 && res.data.status === 'success') {
        this.notifies = { ...res.data.data, data: res.data.data.data };
      }
    },
    async getAgencies() {
      const res = await agency.get('', this.token);
      if (res.status <= 201 && res.data.status === 'success') {
        this.agencies = res.data.data;
      }
    },
    openModal(item) {
      this.modalData = { ...item, newStatus: item.status, newMessage: '' };
      this.bsModal = this.bsModal || new Modal(this.$refs.changeStatusModal, { backdrop: 'static', keyboard: false });
      this.bsModal.show();
    },
    async submitModal(item) {
      if (!this.modalData) return;

      try {
        const { id, newStatus, newMessage } = this.modalData;
        if (newStatus) {
          await notifyReport.updateStatus(id, { status: newStatus }, this.token);
        }

        const agencyStr = item.agency ? `${item.agency.name}/${item.agency.codename}` : '-';
        const residentStr = item.notify && item.notify.resident ? item.notify.resident.name : '-';
        const createdAtStr = item.notify ? new Date(item.notify.created_at).format('yyyy-MM-dd hh:mm:ss') : '-';
        const messageStr = item.notify ? this.$t(`__notifyMessageContent.${item.notify.type}`, { value: item.notify.message }) : '-';
        const staticMessage = [
          this.$t('__notifyManage.notifyReportReply'),
          `${this.$t('__notifyManage.fieldAgency')}: ${agencyStr}`,
          `${this.$t('__notifyManage.fieldResident')}: ${residentStr}`,
          `${this.$t('__notifyManage.fieldCreatedAt')}: ${createdAtStr}`,
          `${this.$t('__notifyManage.fieldMessage')}: ${messageStr}`
        ].join('\n');

        if (newMessage) {
          await chat.sendFromManager({
            agencyId: this.modalData.agency_id,
            content: staticMessage + this.$t('__notifyManage.fieldReply') + newMessage
          }, this.token);
        }

        await this.loadNotifies();

        this.AlertsInfo({
          state: 'success',
          title: this.$t('__success'),
          info: this.$t('__editSuccess')
        });
        this.Alerted();

        this.bsModal.hide();
      } catch (err) {
        this.AlertsInfo({
          state: 'error',
          title: this.$t('__error'),
          info: err.toString()
        });
        this.Alerted();
      }
    },
    statusKey(status) {
      switch (status) {
        case 0: return '__notifyManage.statusPending';
        case 1: return '__notifyManage.statusInProgress';
        case 2: return '__notifyManage.statusDone';
      }
    }
  },
  created() {
    this.loadNotifies(1);
    this.getAgencies();
  }
};
</script>

<style scoped>
</style>

